const menus = [
  {
    item: "menus.home",
    link: "/Home",
    active: false
  },
  {
    item: "menus.about",
    link: "/About",
    active: false
  },
  {
    item: "menus.temple",
    link: "/Temple",
    active: false
  },
  /*{
    item: "menus.society",
    link: "/Society",
    active: false
  },*/
  {
    item: "menus.gaushaala",
    link: "/Gaushaala",
    active: false
  },
  /*{
    item: "menus.panchKalyanak",
    link: "/PanchKalyanak",
    active: false
  },*/
  {
    item: "menus.events",
    link: "/Events",
    active: false
  },
  /*{
    item: "menus.gallery",
    link: "/Gallery",
    active: false
  },*/
  {
    item: "menus.contact",
    link: "/Contact",
    active: false
  }
];

const socialLinks = [
  {
    icon: "facebook2",
    title: "Facebook",
    link: "https://www.facebook.com/Jai-Jinendra-Trust-104179837735478"
  },
  {
    icon: "twitter2",
    title: "Twitter",
    link: "https://twitter.com/trust_jai"
  },
  {
    icon: "linkedin2",
    title: "Linkedin",
    link: "https://linkedin.com/in/jai-jinendra-trust-031043198"
  },
  {
    icon: "youtube",
    title: "YouTube",
    link: "https://www.youtube.com/channel/UCyi1tA9pxX3DMJ25k3OgXNw"
  },
  {
    icon: "whatsapp",
    title: "WhatsApp",
    link: "https://chat.whatsapp.com/GFbl8032P4mD8RKIb8eeJa"
  },
  {
    icon: "telegram",
    title: "Telegram",
    link: "https://t.me/jaijinendratrust"
  }
];

const paymentLink = "https://rzp.io/l/CSzF25F"; //TEST MODE "https://rzp.io/l/GyqksbU";
const headerContactNumber = "+91-9893630475";
const headerEmail = "jaijinendratrust@gmail.com";
const societyPic = "society-pic.jpeg";
const eventPic = "event-pic.png";
const youTube = "https://www.youtube.com/watch?v=";
const APP_TITLE = "JAI JINENDRA TRUST";
const APP_BASE = "/";
const imagePath = "/assets/images/";
const pdfPath = "/assets/pdfs/";
const smallScreenBreakPoint = 699;
const panchkalyanakRegistrationPercent = 54; // This value can be updated dynamically from config or API in future

const documnets = {
  pdfFiles: [
    {
      heading: "OPUS76 PAMPLET 20X30",
      fileName: "PAMPLET_20X30.pdf"
    },
    {
      heading: "OPUS76 BROCHURE",
      fileName: "Opus76_Brochure.pdf"
    },
    /*{
      heading: "COST SHEET - ALL TYPE FLAT",
      fileName: "Cost_Sheet_SNo76.pdf"
    },*/
    {
      heading: "FLOOR PLAN A-TYPE - ODD",
      fileName: "A-TYPE_TYPICAL_1ST_&_3RD_FLOOR_PLAN.pdf"
    },
    {
      heading: "FLOOR PLAN A-TYPE - EVEN",
      fileName: "A-TYPE_TYPICAL_2ND_FLOOR_PLAN.pdf"
    },
    {
      heading: "FLOOR PLAN B-TYPE - ODD",
      fileName: "B-TYPE_TYPICAL_1ST_&_3RD_FLOOR_PLAN.pdf"
    },
    {
      heading: "FLOOR PLAN B-TYPE - EVEN",
      fileName: "B-TYPE_TYPICAL_2ND_FLOOR_PLAN.pdf"
    },
    {
      heading: "FLOOR PLAN C-TYPE - ODD",
      fileName: "C-TYPE_TYPICAL_ODD_FLOOR_PLAN.pdf"
    },
    {
      heading: "FLOOR PLAN C-TYPE - EVEN",
      fileName: "C-TYPE_TYPICAL_EVEN_FLOOR_PLAN.pdf"
    },
    {
      heading: "FLOOR PLAN C-TYPE - REFUGE",
      fileName: "C-TYPE_8TH_REFUGE_FLOOR_PLAN.pdf"
    }
  ]
};

const events = {
  upcomingEvents: [
    {
      videoId: "",
      heading: "events.upcomingEvents.heading1",
      date: "20 NOV 2022",
      time: "10:00 AM",
      place: "Opps76, Wakad, Pune (Maharashtra)"
    }
  ],
  pastEvents: [
    {
      videoId: "9DIjbdg7a6Q",
      heading: "events.pastEvents.heading1",
      date: "23 SEP 2021",
      time: "09:00 AM",
      place: "Opps76, Wakad, Pune (Maharashtra)"
    },
    {
      videoId: "6ozYCdAQ0ME",
      heading: "events.pastEvents.heading2",
      date: "14 SEP 2019",
      time: "09:00 AM",
      place: "Opps76, Wakad, Pune (Maharashtra)"
    }
  ]
};

const newsFeed = {
  news: [
    {
      date: "06 MAR 2024",
      headline: "newsFeed.headline1",
      description: "newsFeed.headline1.description"
    },
    {
      date: "06 MAR 2024",
      headline: "newsFeed.headline2",
      description: "newsFeed.headline2.description"
    }
  ]
};

const cardsData = {
  cards: [
    {
      image: "acharya_shanti_sagar.jpg",
      heading: "cardsData.heading1",
      description: "cardsData.heading1.description"
    },
    {
      image: "india_nahi_bharat.jpg",
      heading: "cardsData.heading2",
      description: "cardsData.heading2.description"
    },
    {
      image: "samay-sagar-maharaj.webp",
      heading: "cardsData.heading3",
      description: "cardsData.heading3.description"
    },
  ]
};

const donation = [
  {
    type: "donation.type1",
    amount: "Rs. 11,11,111 /-"
  },
  {
    type: "donation.type2",
    amount: "Rs. 5,55,555 /-"
  },
  {
    type: "donation.type3",
    amount: "Rs. 1,21,000 /-"
  },
  {
    type: "donation.type4",
    amount: "Rs. 71,000 /-"
  },
  {
    type: "donation.type5",
    amount: "Rs. 51,000 /-"
  },
  {
    type: "donation.type6",
    amount: "Rs. 21,000 /-"
  },
  {
    type: "donation.type7",
    amount: "Rs. 11,000 /-"
  },
  {
    type: "donation.type8",
    amount: "Rs. 5,555 /-"
  },
  {
    type: "donation.type9",
    amount: "Rs. 3,500 /-"
  },
  {
    type: "donation.type10",
    amount: "Rs. 2,100 /-"
  },
  {
    type: "donation.type11",
    amount: "Rs. 1,100 /-"
  },
  {
    type: "donation.type12",
    amount: "Rs. 501 /-"
  },
  {
    type: "donation.type13",
    amount: "Rs. 251 /-"
  },
  {
    type: "donation.type14",
    amount: "Rs. 101 /-"
  },
  {
    type: "donation.type15",
    amount: "Rs. 51 /-"
  },
  {
    type: "donation.type16",
    amount: "-"
  }
]

const api = {
  register: "https://rp0lmrjc21.execute-api.ap-south-1.amazonaws.com/register",
  users: "https://rp0lmrjc21.execute-api.ap-south-1.amazonaws.com/users",
  pushpBrashtiRegister: "https://o5pn494yi8.execute-api.ap-south-1.amazonaws.com/register",
  pushpBrashtiUsers: "https://o5pn494yi8.execute-api.ap-south-1.amazonaws.com/users"
}

export const constants = {
  APP_TITLE,
  APP_BASE,
  imagePath,
  pdfPath,
  menus,
  socialLinks,
  paymentLink,
  headerContactNumber,
  headerEmail,
  societyPic,
  eventPic,
  youTube,
  smallScreenBreakPoint,
  documnets,
  events,
  newsFeed,
  cardsData,
  donation,
  api,
  panchkalyanakRegistrationPercent
};
